export enum ViewOptionCategories {
    ALL = 'All',
    VISIT_NOTES = 'Visits',
    MESSAGES = 'Messages',
    ATTACHMENTS = 'Attachments',
    RESULTS = 'Results',
    EPISODES_OF_CARE = 'EpisodesOfCare'
}
